import IndividualTable from '../../../IndividualTable';
import { sampleData } from "../../sampleData";

const Distance145 = () => {
  let winners = ["152"];
  return <IndividualTable matchType={"3"} gender="M" event="145" subTitle="Kungdo" data={sampleData} topRankCount="1" winners={winners} />;
};
export default Distance145;
